<script>
import ArticleContent from "@/components/article/ArticleContent.vue";
import ArticleContentCollapser from "@/components/article/ArticleContentCollapser.vue";
import lang from "@/directives/lang";

import ArticleContentHeader from "./ArticleContentHeader.vue";
import ArticleMeanings from "./ArticleMeanings.vue";
import ArticleProverbs from "./ArticleProverbs.vue";
import ArticleSublemmas from "./ArticleSublemmas.vue";

export default {
  name: "CurrentDanishArticleContent",
  components: {
    ArticleContent,
    ArticleContentHeader,
    ArticleContentCollapser,
    ArticleMeanings,
    ArticleProverbs,
    ArticleSublemmas
  },
  directives: {
    lang
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    hasReadingLines: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    isCollapsible: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<template>
  <ArticleContent>
    <ArticleContentHeader :word="article.word"></ArticleContentHeader>

    <ArticleContentCollapser :is-collapsible="isCollapsible">
      <div
        class="article-content__body-container"
        :class="{ 'article-content__body-container--reading-lines': hasReadingLines }"
      >
        <ArticleMeanings
          v-if="article.meanings.length > 0"
          :meanings="article.meanings"
        ></ArticleMeanings>
      </div>
      <ArticleProverbs
        v-if="article.proverbs.length > 0"
        :proverbs="article.proverbs"
      ></ArticleProverbs>
      <ArticleSublemmas
        v-if="article.sublemmas.length > 0"
        :sublemmas="article.sublemmas"
      ></ArticleSublemmas>
    </ArticleContentCollapser>
  </ArticleContent>
</template>
